import React from 'react';
import localization from '../../localization';
import { ILocaleContext } from './types';

const LocaleContext = React.createContext<ILocaleContext>({
  locale: localization.base,
});

export default LocaleContext;
